var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('i',{class:_vm.icon}),_c('div',{staticClass:"error-page-desc"},[_vm._v(" "+_vm._s(_vm.desc)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }